import camelCase from 'lodash/fp/camelCase';
import flow from 'lodash/fp/flow';
import isArray from 'lodash/fp/isArray';
import isPlainObject from 'lodash/fp/isPlainObject';
import mapKeys from 'lodash/fp/mapKeys';
import mapValues from 'lodash/fp/mapValues';
import snakeCase from 'lodash/fp/snakeCase';

export const toCamelCase = <T>(input: unknown): T => {
    if (typeof input === 'object' && input !== null) {
        if (isArray(input)) {
            return (input as unknown[]).map(toCamelCase) as T;
        }

        if (isPlainObject(input)) {
            return flow(mapKeys(camelCase), mapValues(toCamelCase))(input) as T;
        }
    }

    return input as T;
};

export const toSnakeCase = <T>(input: unknown): T => {
    if (typeof input === 'object' && input !== null) {
        if (isArray(input)) {
            return (input as unknown[]).map(toSnakeCase) as T;
        }

        if (isPlainObject(input)) {
            return flow(mapKeys(snakeCase), mapValues(toSnakeCase))(input) as T;
        }
    }

    return input as T;
};
